import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import apiRuntime from '~/api/runtime';

type PipelineVersionsVariables = {
  realm: string;
  environment: string;
  id: string;
};

export const usePipelineVersions = () => {
  const queryClient = useQueryClient();

  const fetchPipelineVersions = useCallback(
    (variables: PipelineVersionsVariables) =>
      queryClient.fetchQuery({
        queryKey: [
          'run',
          'pipelineVersions',
          variables.realm,
          variables.environment,
          variables.id
        ],
        queryFn: () => apiRuntime.pipelineVersions(variables),
        staleTime: 0,
        gcTime: 0
      }),
    [queryClient]
  );

  return { fetchPipelineVersions };
};
